import { useContext, useEffect, useState } from "react";
import {
  Container,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
  IconButton,
} from "@material-ui/core";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddIcon from "@material-ui/icons/Add";

import { useHistory } from "react-router";
import { ClienteContextProvider } from "./contexts/ClienteContext";

import HeaderModule from "../../../components/header/HeaderModule";
import { PainelContainer, TableContent } from "./styles/Cliente";
import MaskService from "../../../utils/mask/maskService";
import Btn from "../../../components/buttons/Btn";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import useClienteController from "./controllers/ClienteController";
import Loading from "../../../components/basics/Loading";

import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";

import { BallContainer } from "./styles/Cliente";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import BigDataTable from "../../../components/tables/BigDataTable";

import WhatsappButton from "../../../components/whatsappButton/WhatsappButton";
import ModalParameters from "../../../patterns/modals/modalparameters/ModalParameters";
import { Settings } from "@material-ui/icons";
import { findUsuarios } from "../../../repositories/qerpapi/erp/acesso/v1/UsuarioRepository";
import { notify } from "../../../utils/notify";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { GlobalVariables } from "../../../GlobalVariables";

let typingTimer = null;
const View = () => {
  const { queryParams } = useContext(QueryParamsContext);
  // eslint-disable-next-line
  const [viewLoading, setViewLoading] = useState(false);

  const [textFilter, setTextFilter] = useState("");
  const [showOnlyActives, setShowOnlyActives] = useState(true);
  const [queryOrWhere, setQueryOrWhere] = useState({});
  const [queryOrWhereTranslate, setQueryOrWhereTranslate] = useState(null);
  const [queryWhere, setQueryWhere] = useState({});
  // eslint-disable-next-line
  const [reload, setReload] = useState(false);

  // eslint-disable-next-line
  const { clearCutomerContext, handleDeleteClient } = useClienteController();
  const { push } = useHistory();

  const columns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => (
        <SpeedDialErp
          actions={[
            {
              icon: <EditOutlinedIcon />,
              name: "Editar",
              action: () => push("cadastro", { item }),
            },
            //{ A PEDIDO DA SUPERIORIDADE, MANTER COMENTADO POR ENQUANTO
            //  icon: <DeleteOutlined />,
            //  name: "Excluir",
            //  action: () =>
            //    handleDeleteClient(item.id, setViewLoading, setReload, item.id !== 1),
            //},
          ]}
        />
      ),
    },
    {
      id: "id",
      label: "ID",
    },
    {
      id: "razao",
      label: "Razão",
    },
    {
      id: "apelido",
      label: "Fantasia",
    },
    {
      id: "cpfcnpj",
      label: "CNPJ/CPF/CÓD",
      format: (item) => {
        let clientInfo,
          replacedInfo = item?.cpfcnpj?.replace(/[^0-9]+/g, "") ?? "-";

        if (replacedInfo.length === 11)
          clientInfo = MaskService.toMask("cpf", replacedInfo);
        else if (replacedInfo.length === 14)
          clientInfo = MaskService.toMask("cnpj", replacedInfo);
        else clientInfo = replacedInfo;

        return clientInfo;
      },
    },
    {
      id: "email",
      label: "E-mail",
    },
    {
      id: "endereco",
      label: "Município",
      format: (item) => {
        let final = `${item.cidade} - ${item?.estado?.estado}`;

        return final;
      },
    },
    {
      id: "telefone",
      label: "Telefone",
      format: (item) =>
        item.telefone1 && item.ddd1
          ? MaskService.toMask("cel-phone", item.ddd1 + item.telefone1)
          : item.telefone1
          ? MaskService.toMask("cel-phone", "00" + item.telefone1)
          : "",
    },
    {
      id: "whatsapp_ativo",
      label: "Celular",
      format: (item) => {
        item.whatsapp_ativo = !!item?.clientescontatos?.find(
          (e) => e.whatsapp_ativo === 1 && e.principal === 1
        )?.celular;
        return (
          <>
            {item.whatsapp_ativo && (
              <div>
                <WhatsappButton
                  celular={MaskService.toMask(
                    "cel-phone",
                    item?.clientescontatos?.find(
                      (e) => e.whatsapp_ativo === 1 && e.principal === 1
                    )?.celular
                  )}
                />
              </div>
            )}
          </>
        );
      },
    },
    {
      id: "ativo",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.ativo === "S" ? (
          <BallContainer>
            <img src={GreenBall} alt="Ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="Inativo" />
          </BallContainer>
        ),
    },
  ];

  useEffect(() => {
    clearCutomerContext();
  }, [clearCutomerContext]);

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setQueryOrWhere({
        razao: encodeURIComponent(`${textFilter}`),
        apelido: encodeURIComponent(`${textFilter}`),
        ie: `${textFilter}`,
        id: `${textFilter}`,
        email: encodeURIComponent(`${textFilter}`),
        telefone1: encodeURIComponent(`${textFilter}`),
        cpfcnpj: `${textFilter.replace(/[^0-9]/g, "") || null}`,
      });
    }, 1500);
  }, [textFilter]);

  useEffect(() => {
    setQueryWhere({ ativo: showOnlyActives ? "S" : "N" });
  }, [showOnlyActives]);

  const [modalParametersOpen, setModalParametersOpen] = useState(false);
  const [ableToOpenModal, setAbleToOpenModal] = useState(false);

  useEffect(() => {
    if (!queryParams.usuario_id || !queryParams.empresa_cnpj) return;

    findUsuarios(
      queryParams.empresa_cnpj,
      queryParams.usuario_id,
      "grupos"
    ).then((res) => {
      if (!res.success)
        return notify("Não foi possível encontrar o grupo de usuário.");

      const permission =
        (res.data?.grupos || []).some((el) => el.id === 32) || false;
      setAbleToOpenModal(permission);
    });
  }, [queryParams.usuario_id, queryParams.empresa_cnpj]);

  return (
    <>
      {modalParametersOpen && (
        <ModalParameters
          open={modalParametersOpen}
          setOpen={setModalParametersOpen}
          entity="clientes"
        />
      )}

      <Loading open={viewLoading} />
      <HeaderModule
        title="CADASTRO DE CLIENTES"
        videoId={GlobalVariables.screenVideosIds.cadastroCliente}
        receivedChild={
          <Grid item>
            {ableToOpenModal && (
              <IconButton
                onClick={() => setModalParametersOpen((current) => !current)}
              >
                <Settings />
              </IconButton>
            )}
          </Grid>
        }
      />

      <PainelContainer />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item container justify="space-between" alignItems="flex-end">
            <Grid item xs={12} sm={12} md={7}>
              <TextFieldErp
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Razão, Fantasia, CPF/CNPJ/CÓD, Email ou Telefone "
                variant="filled"
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyActives}
                    onChange={() => setShowOnlyActives((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativos"
                labelPlacement="end"
              />
            </Grid>
            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<AddIcon />}
                onClick={() => push("cadastro")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TableContent>
              <BigDataTable
                tableTitle=""
                route="prouser/clientes/v1"
                columns={columns}
                include="clientescontatos,estado"
                where={queryWhere}
                orWhere={queryOrWhere}
                orWhereTranslate={queryOrWhereTranslate}
                reload={reload}
              />
            </TableContent>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

const ClienteListagem = () => (
  <ClienteContextProvider>
    <View />
  </ClienteContextProvider>
);

export default ClienteListagem;
